import { Box, Button, styled, Tab, Tabs, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_TEXT,
  ERROR_BUTTON_BACKGROUND,
  ERROR_BUTTON_BORDER,
  LIGHT_HEADER_LINE,
  LIGHT_TEXT,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_HEADER_BORDER,
  PRIMARY_HEADER_LINE,
  PRIMARY_TEXT,
} = COLORS;

export const MainCont = styled(Box)(() => ({}));

export const TabHeader = styled(Tabs)(({ theme }) => ({
  // Media top menu background, removed for now
  // background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: 4,
  marginBottom: 10,
  '& .MuiTab-root': {
    minWidth: 'unset',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: PRIMARY_HEADER_LINE,
  },
  '& .PrivateTabIndicator-colorSecondary-2381': {
    backgroundColor: 'none',
  },
}));

export const TabItem = styled(Tab)(() => ({
  opacity: 1,
  '&.Mui-selected': {
    color: PRIMARY_TEXT,
  },
}));

export const ActiveTabContainer = styled(Box)(() => ({
  flex: 1,
}));

export const TabContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
}));

export const HeaderCont = styled(Box)(({ theme }) => ({
  margin: '0 10px 10px 10px',
  padding: 10,
  borderBottom:
    theme.palette.type === 'dark' ? `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}` : `1px solid ${LIGHT_HEADER_LINE}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  [theme.breakpoints.down('md')]: {
    justifyContent: 'start',
    alignItems: 'start',
    flexDirection: 'column',
    gap: 10,
  },
}));

export const TitleCont = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 15,
}));

export const HeaderButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down(960)]: {
    width: 'unset',
    fontSize: 8,
    padding: '0px 12px',
  },
  width: 147,
  height: 36,
  border: `solid 1px ${PRIMARY_HEADER_BORDER}`,
  borderRadius: 4,
  marginLeft: 'auto',
  backgroundColor: 'transparent',
}));

export const DeleteCont = styled(Box)(({ theme }) => ({
  margin: '0 10px 10px 10px',
  padding: '10px 10px 20px 10px ',
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_HEADER_LINE : LIGHT_HEADER_LINE,
  display: 'flex',
  alignItems: 'center',
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down(960)]: {
    fontSize: 10,
    padding: '0 10px',
  },
  height: 36,
  border: `1px solid ${ERROR_BUTTON_BORDER}`,
  padding: '0 32px',
  fontSize: 13,
  backgroundColor: 'transparent',
}));

export const ModalCont = styled(Box)(({ theme }) => ({
  width: 500,
  height: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 40,
  position: 'relative',
  [theme.breakpoints.down(960)]: {
    width: 'unset',
    height: 'unset',
    justifyContent: 'center',
    padding: '30px 20px',
    wordBreak: 'break-word',
  },
}));

export const DeleteModalButton = styled(Button)(({ theme }) => ({
  width: 258,
  height: 44,
  backgroundColor: ERROR_BUTTON_BACKGROUND,
  color: PLAIN_TEXT,
  '&:hover': {
    backgroundColor: ERROR_BUTTON_BACKGROUND,
    opacity: 0.9,
  },
}));

export const CancelModalButton = styled(Button)(() => ({
  width: 258,
  height: 44,
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  marginTop: 15,
  backgroundColor: 'transparent',
}));

export const ButtonCont = styled(Box)(() => ({
  marginTop: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const TextGreyColor = styled(Typography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? LIGHT_TEXT : DARK_TEXT,
}));
